import React, { useContext, useRef } from 'react';
import { connect } from 'react-redux';
import { Button, Typography } from 'antd';
import { openPickPoint } from '../../modules/points/actions/openPickPoint';
import { HomeOutlined } from '@ant-design/icons';
import { NavbarItemMobile } from 'app/components/navbar/NavbarItemMobile';
import _ from 'underscore';
import { useHeightWatcher } from 'app/hooks/useHeightWatcher';
import { Context } from 'app/index';
import { MenuTypes } from 'app/components/navbar/Navbar';
import classNames from 'classnames';

const NavbarHeader = ({ setting }) => {
    const ref = useRef();
    useHeightWatcher(ref, 'nav-header');
    const {
        settings: {
            navbar: { settings: navbarSettings },
        },
    } = useContext(Context);
    const isCompact = navbarSettings.type === MenuTypes.compact;
    return (
        <div ref={ref} className={'header-information'}>
            <nav
                className="navbar-container"
                style={{
                    color: setting.content.navbar.color,
                    background: setting.content.navbar.background,
                }}
            >
                <NavbarItemMobile
                    name={setting.content.primary.name}
                    icon={<HomeOutlined />}
                    to={'/'}
                />
                {_.map(setting.content.pages, (page, key) => {
                    return (
                        <NavbarItemMobile
                            key={key}
                            to={`/${page.title}`}
                            name={page.name}
                        />
                    );
                })}
            </nav>
            {isCompact ? null : <HeaderInformationConnect />}
        </div>
    );
};

function HeaderInformation({ point, dispatch, response, setting, className }) {
    function onPoint() {
        dispatch(openPickPoint(true));
    }
    const { phone, text } = setting.content.navbar;
    const points_lists = response?.lists;
    return (
        <div className={classNames('header-information__extra', className)}>
            {text ? (
                <div className={'header-information__extra__description'}>
                    {text}
                </div>
            ) : null}
            {phone ? (
                <Typography.Link
                    className={'header-information__extra__phone'}
                    href={`tel:${phone}`}
                >
                    {phone}
                </Typography.Link>
            ) : null}
            {points_lists?.length > 1 ? (
                <Button type={'link'} tabIndex={1} onClick={onPoint}>
                    <HomeOutlined /> • {point?.name}
                </Button>
            ) : null}
        </div>
    );
}

export const HeaderInformationConnect = connect((state) => {
    return {
        setting: state.appState.setting,
        response: state.pointsState.points.response,
        point: state.shopState.order.point,
    };
})(HeaderInformation);

const props = (state) => {
    return {
        setting: state.appState.setting,
    };
};

export const NavbarHeaderContainer = connect(props)(NavbarHeader);
